import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SolicitudService } from 'app/services/solicitud.service';

@Component({
  selector: 'app-alcance-titulos',
  templateUrl: './alcance-titulos.component.html',
  styleUrls: ['./alcance-titulos.component.scss']
})
export class AlcanceTitulosComponent implements OnInit {
  idsolicitud: string;
  solicitud: any;

  constructor(private route: ActivatedRoute,private solicitudService: SolicitudService,) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.idsolicitud = params['id'];
    });
    
    if (this.idsolicitud) { this.loadExpediente(this.idsolicitud); }

  }


  private loadExpediente(idsolicitud) {
    this.solicitudService.get(idsolicitud).subscribe(
      data => {this.solicitud = data;},
      error => {if (error.status = 401) {alert('Error de conexión con datos'); }}
    );
  }


}



// WEBPACK FOOTER //
// /app/src/app/modules/general/alcance-titulos/alcance-titulos.component.ts